/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VehicleType } from '../../models/vehicle-type';
import { VehicleTypeCreateRequest } from '../../models/vehicle-type-create-request';

export interface CreateVehicleType$Params {
      body: VehicleTypeCreateRequest
}

export function createVehicleType(http: HttpClient, rootUrl: string, params: CreateVehicleType$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleType>> {
  const rb = new RequestBuilder(rootUrl, createVehicleType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehicleType>;
    })
  );
}

createVehicleType.PATH = '/api/v1/vehicle_types';
